import { Button, Card } from 'react-bootstrap';
import { ProfileProgress } from '../ProfileProgress';

export const ProfileIncompleteCard = ({
  progress,
  className = 'my-3',
}: {
  progress: number;
  className?: string;
}) => {
  return (
    <Card className={className}>
      <Card.Body className="p-4">
        <p className="text-center profile-incomplete--text mb-3 pb-2">
          Please complete the onboarding process so that you can be listed on the Marketplace!
        </p>
        <ProfileProgress progress={progress} compact={true} />
        <div className="d-flex py-2 justify-content-center">
          <a href="/app/provider/onboarding">
            <Button className="mt-4 shadow bg-danger" size="lg" variant="primary">
              Finish Onboarding
            </Button>
          </a>
        </div>
      </Card.Body>
    </Card>
  );
};
